import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Topbar from '../Topbar';

export default function Layout() {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '100%', backgroundColor: '#FFF' }}>
      <Sidebar isOpenSidebar={isOpen} handler={setIsOpen} />
      <div
        style={{
          width: isOpen
            ? 'calc(100% - var(--sidebar-content-margin-expanded, 276px))'
            : 'calc(100% - var(--sidebar-collapsed-width, 76px))',
          overflow: 'auto',
          marginLeft: isOpen
            ? 'var(--sidebar-content-margin-expanded, 276px)'
            : 'var(--sidebar-collapsed-width, 76px)',
          height: '100%',
          
          transition: 'width var(--sidebar-transition-duration, 220ms) ease, margin-left var(--sidebar-transition-duration, 220ms) ease',
        }}
      >
        <Topbar />
        <Outlet />
      </div>
    </div>
  );
}
